<template>
  <!-- <PageLoader /> -->
  <BGMap />
  <IntroModal />
  <template v-if="!showIntro">
    <Header />
    <PageFooterLinks />
    <JourneyOverlay />

    <!-- Only the rail needs gating; the rest self-gate and render nothing during a
             journey. Leaving them mounted is what lets their own enter transitions
             play on the way back — none of them sets `appear`. -->
    <Transition name="panel-left">
      <ModalImpacts v-if="!activeJourney" />
    </Transition>

    <ModalHighlights />
    <TakeActionModal />
    <ExtendedReader />
    <FooterDocModal />
  </template>
</template>

<script setup lang="ts">
import '~/scopes/campaign/assets/css/index.css'
import 'mapbox-gl/dist/mapbox-gl.css'

import { toPublicPath, useHead } from '#imports'

import BGMap from '~/scopes/campaign/components/BGMap.vue'
import ExtendedReader from '~/scopes/campaign/components/ExtendedReader.vue'
import ModalHighlights from '~/scopes/campaign/components/ModalHighlights.vue'
import ModalImpacts from '~/scopes/campaign/components/ModalImpacts.vue'
import FooterDocModal from '~/scopes/campaign/components/footer/FooterDocModal.vue'
import PageFooterLinks from '~/scopes/campaign/components/footer/PageFooterLinks.vue'
import Header from '~/scopes/campaign/components/header/Header.vue'
import IntroModal from '~/scopes/campaign/components/intro/IntroModal.vue'
import JourneyOverlay from '~/scopes/campaign/components/journey/JourneyOverlay.vue'
import TakeActionModal from '~/scopes/campaign/components/takeAction/TakeActionModal.vue'
import { useCampaignSeo } from '~/scopes/campaign/composables/useCampaignSeo'
import { useIntroState } from '~/scopes/campaign/composables/useIntroState'
import { useModalState } from '~/scopes/campaign/composables/useModalState'

// const { market } = useMarketplace()
const { showIntro } = useIntroState()
const { activeJourney } = useModalState()

// One title / description / share card for the whole campaign, plus lang + canonical.
useCampaignSeo()

useHead({
  link: [
    {
      rel: 'preload',
      href: toPublicPath('/mine-my-phone/fonts/Inter-Variable.woff2'),
      as: 'font',
      type: 'font/woff2',
      crossorigin: '',
    },
  ],
})
</script>
